export default __webpack_public_path__ + "static/media/LightSourceImg.7ee7dfc0.jpg";